const coreTranslate = {}

export default coreTranslate
